import React from 'react'
import {Container, Card, Col, Button, OverlayTrigger, Popover, Placement, Tooltip, Accordion} from 'react-bootstrap'
import moment from 'moment'
import { GiBrain, GiMeditation } from "react-icons/gi";
import { MdAvTimer } from "react-icons/md";
import { RiDeleteBin6Line, RiPencilLine } from "react-icons/ri";


export default function Journal(props) {

  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">Are you sure?</Popover.Header>
      <Popover.Body>
        It will be gone forever. <Button className="icons-buttons" variant="light" size="sm" onClick={() => {props.deleteJournal(props._id)}}>Delete</Button>
      </Popover.Body>
    </Popover>
  );


  console.log(props)
  return (
    <> 
    
    <Col sm={8} className="center-form">

    
      <Card border="danger">
          <Card.Header as="h6" className="card-header">        
            &nbsp;<GiMeditation/>&nbsp;{props.meditation.name} &nbsp;|&nbsp; Focus Level: {props.focusLevel}  
          </Card.Header>        
          <Card.Body>
          {/* <Card.Title as="h4" className="text-center">{props.meditation.name} </Card.Title> */}
          <Card.Text>
            <span className="text-muted">Minutes completed:</span> {props.description}<br></br>
            <span className="text-muted">How it went:</span> {props.notes}<br></br>
            <span className="text-muted">Recorded:</span> {moment(props.createdAt).calendar()}
          </Card.Text>
          </Card.Body>         
          <Card.Footer className="text-muted">
                
                <Button className="icons-buttons" variant="link" size="sm" onClick={() => {props.editView(props._id); props.setModalShow(true)}}><RiPencilLine/></Button>         
                <OverlayTrigger trigger="click" placement="right" overlay={popover} rootClose={true}>
                  <Button className="icons-buttons" variant="link" size="sm"><RiDeleteBin6Line/></Button>
                </OverlayTrigger>
                
          
          </Card.Footer>
      </Card>
      </Col>
   
      <br /> 








    </>
  )
}
